import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SupportChatBot from "./SupportChatBot";
import InstallPWA from "./InstallPWA";
import PromoStrip from "./PromoStrip";
import TrafficPing from "./TrafficPing";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <TrafficPing />
            <PromoStrip />
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <SupportChatBot />
            <InstallPWA />
        </div>
    );
}
